import React from "react"
import Header from "../components/Header"
import { Paper } from "@mui/material"
import JobsToBeDoneForm from "../components/JobsToBeDoneForm"
import { spacing } from "../pages/services/styleServices"

const styles = {
    pageContent: {
        margin: spacing(2),
        padding: spacing(2),
    },
}

const JobsToBeDone = (props) => {
    return (
        <Header title="Jobs To Be Done">
            <Paper sx={styles.pageContent}>
                <JobsToBeDoneForm {...props} />
            </Paper>
        </Header>
    )
}

export default JobsToBeDone
